import React, { Component } from "react";
import { Row, Col, Card, Table, Button } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  
  URL,
  fotoStyle2,
  localFilePath,
} from "../../redux/actions/constants";
import fileIcon from "../../images/file.jpg";
class CargoTrackingDetail extends Component {
  state = {
    pageTitle: "Kargo Takip Detay",
    pageTitleDetail: "Kargo Takip Detay",
    pageAddLink: "kargo-takip-ekle",
    pageListLink: "kargo-takip-listele",
    breadcrumb: [{ text: "Kargo Takip", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    arrivedDate: "",
    shippingTypeName: "",
    shippingCompaniesName: "",
    customerName: "",
    description: "",
    isCustomerInfo: "",
    isScanner: "",
    isWhatsapp: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
    statusDateTime: "",
    cargoTrackingDocumentDto: [],
  };
  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/cargotracking/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            arrivedDate: response.data.arrivedDate,
            shippingTypeName: response.data.shippingTypeName,
            shippingCompaniesName: response.data.shippingCompaniesName,
            customerName: response.data.customerName,
            description: response.data.description,
            isCustomerInfo: response.data.isCustomerInfo,
            isScanner: response.data.isScanner,
            isWhatsapp: response.data.isWhatsapp,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            statusDateTime: response.data.statusDateTime,
            cargoTrackingDocumentDto: response.data.cargoTrackingDocumentDto,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }
  fileClick = (image) => {
    let urlWebSite = "http://sys.cogenteknoloji.com";
    let urlSplit = window.location.hostname;
    if (urlSplit === "crm.cevirikalitesi.com") {
      urlWebSite = "https://www.cevirikalitesi.com";
    }

    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open(urlWebSite + "/Files/" + myData, "_blank");
      this.setState({
        isLoadingParent: false,
      });
    }
  };
  render() {
    var self1 = this;
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Geldiği Tarih</th>
                    <td colSpan="4">{this.state.arrivedDate}</td>
                  </tr>
                  <tr>
                    <th>Kargo Türü</th>
                    <td colSpan="4">{this.state.shippingTypeName}</td>
                  </tr>
                  <tr>
                    <th>Kargo Firması</th>
                    <td colSpan="4">{this.state.shippingCompaniesName}</td>
                  </tr>
                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">{this.state.customerName}</td>
                  </tr>
                  <tr>
                    <th>İçinde Ne Var? (Kaç Adet Dosya vb.)</th>
                    <td colSpan="4">
                      {this.state.description ? this.state.description : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Müşteri Bilgilendirildi Mi?</th>
                    <td colSpan="4">
                      {this.state.isCustomerInfo ? "Evet" : "Hayır"}
                    </td>
                  </tr>
                  <tr>
                    <th>Tarama Yapıldı Mı?</th>
                    <td colSpan="4">
                      {this.state.isScanner ? "Evet" : "Hayır"}
                    </td>
                  </tr>
                  <tr>
                    <th>Whatsapp Gönderildi Mi?</th>
                    <td colSpan="4">
                      {this.state.isWhatsapp ? "Evet" : "Hayır"}
                    </td>
                  </tr>
                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">
                      {this.state.status === 1
                        ? "Bekliyor"
                        : this.state.status === 2
                        ? "İşlemde"
                        : this.state.status === 3
                        ? "Tamamlandı"
                        : this.state.status === 4
                        ? "Teslim Edildi"
                        : this.state.status === 5
                        ? "İptal Edildi"
                        : "İade Edildi"}
                    </td>
                  </tr>
                  <tr>
                    <th>Tarih</th>
                    <td colSpan="4">
                      {this.state.statusDateTime !== ""
                        ? this.state.statusDateTime
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
              {this.state.cargoTrackingDocumentDto &&
                this.state.cargoTrackingDocumentDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2">
                    <tr style={mainRow}>
                      <th>Belgeler</th>
                    </tr>
                    <Row>
                      {this.state.cargoTrackingDocumentDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-4">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={fileIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}
export default CargoTrackingDetail;
